import { roundedClassname } from '@/helpers/environmentHelper';
import { useAppSelector } from '@/state/hooks';
import { selectNotifications } from '@/state/reducers/notificationSlice';
import cn from 'classnames';
import { Fragment, useMemo } from 'react';
import { MdNotifications } from 'react-icons/md';

interface NotificationButtonProps {
    size: string;
    isActive: boolean;
    hasBorders?: boolean;
    onClick(): void;
}

const NotificationButton = ({ size, isActive, hasBorders = true, onClick }: NotificationButtonProps) => {
    const notifications = useAppSelector(selectNotifications);

    const unseenCount = useMemo(() => {
        return notifications.filter((notification) => !notification.seen).length;
    }, [notifications]);

    const ping = useMemo(() => {
        const latest = notifications[0];
        if (latest) {
            switch (latest.type) {
                case 'info':
                    return {
                        dot: 'bg-sky-500',
                        wave: 'bg-sky-400'
                    };
                case 'success':
                    return {
                        dot: 'bg-brand-green',
                        wave: 'bg-brand-green-light'
                    };
                case 'error':
                    return {
                        dot: 'bg-brand-red',
                        wave: 'bg-brand-red-light'
                    };
                default:
                    return false;
            }
        }
        return false;
    }, [unseenCount, notifications[0]]);

    return (
        <button
            type="button"
            className={cn(
                'inline-flex lg:my-0 items-center justify-center text-brand-text focus:outline-none transition duration-150 ease-in-out hover:text-brand-primary-light',
                {
                    ['bg-brand-primary']: isActive && hasBorders,
                    ['bg-brand-background-dark border border-brand-neutral-700 hover:border-brand-neutral-600 p-1 px-2 lg:px-1 my-1']:
                        hasBorders
                },
                roundedClassname
            )}
            onClick={onClick}>
            <div
                className={cn('relative flex', size, {
                    ['animate-wiggle']: ping && unseenCount > 0
                })}>
                {ping && unseenCount > 0 && (
                    <Fragment>
                        <span
                            className={cn(
                                'z-[2] absolute top-1 right-0 h-2.5 w-2.5 opacity-75 animate-ping',
                                {
                                    [ping.wave]: true
                                },
                                roundedClassname
                            )}
                        />
                        <span
                            className={cn(
                                'z-[2] absolute top-1 right-0 h-2.5 w-2.5 border-[1px] border-brand-background text-[8px]',
                                {
                                    [ping.dot]: true
                                },
                                roundedClassname
                            )}
                        />
                        {/* {unseenCount} */}
                        {/* {unseenCount > 0 && (
                            <span className="absolute top-0 right-0 bg-brand-red-light text-brand-module-title rounded-full w-5 h-5 flex items-center justify-center text-xs">
                                {unseenCount}
                            </span>
                        )} */}
                    </Fragment>
                )}
                <MdNotifications className={cn('absolute z-[1]', size)} />
            </div>
        </button>
    );
};

export default NotificationButton;
